import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/pemserter-price-list-eur*` admin CRUD over the EUR projection
// of haeger_pemserter_price_list. Numerics are decimal STRINGS on the wire
// (§J — never float for money).

export interface PemserterPriceListEur {
  rowId: number;
  itemNumber: string | null;
  itemName: string | null;
  /** numeric(14,6) — decimal string. */
  customerSalesPriceEur: string | null;
  /** numeric(14,6) — decimal string. */
  distributorNetPriceEur: string | null;
  /** numeric(18,10). */
  discountRate: string | null;
  /** numeric(10,4). */
  discountPercent: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PemserterPriceListEurPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedPemserterPriceListEur {
  data: PemserterPriceListEur[];
  pagination: PemserterPriceListEurPagination;
}

export interface ListPemserterPriceListEurParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface CreatePemserterPriceListEurBody {
  itemNumber: string;
  itemName: string;
  customerSalesPriceEur?: string | number | null;
  distributorNetPriceEur?: string | number | null;
  discountRate?: string | number | null;
  discountPercent?: string | number | null;
}

export type UpdatePemserterPriceListEurBody = Partial<CreatePemserterPriceListEurBody>;

const BASE = "/v1/pemserter-price-list-eur";

/** GET /v1/pemserter-price-list-eur — paginated, soft-deleted excluded. */
export async function listPemserterPriceListEur(
  params: ListPemserterPriceListEurParams = {},
): Promise<PaginatedPemserterPriceListEur> {
  const res = await Api.get(BASE, { params });
  return unwrap<PaginatedPemserterPriceListEur>(res.data);
}

/** GET /v1/pemserter-price-list-eur/:id. */
export async function getPemserterPriceListEur(
  rowId: number,
): Promise<PemserterPriceListEur> {
  const res = await Api.get(`${BASE}/${rowId}`);
  return unwrap<PemserterPriceListEur>(res.data);
}

/** POST /v1/pemserter-price-list-eur. */
export async function createPemserterPriceListEur(
  body: CreatePemserterPriceListEurBody,
): Promise<PemserterPriceListEur> {
  const res = await Api.post(BASE, body);
  return unwrap<PemserterPriceListEur>(res.data);
}

/** PUT /v1/pemserter-price-list-eur/:id. */
export async function updatePemserterPriceListEur(
  rowId: number,
  body: UpdatePemserterPriceListEurBody,
): Promise<PemserterPriceListEur> {
  const res = await Api.put(`${BASE}/${rowId}`, body);
  return unwrap<PemserterPriceListEur>(res.data);
}

/** DELETE /v1/pemserter-price-list-eur/:id (soft-delete). */
export async function deletePemserterPriceListEur(rowId: number): Promise<void> {
  await Api.delete(`${BASE}/${rowId}`);
}
